/**
 * Stores build information. The string literals are replaced at compile time by `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-09-27",
    versionChannel: "nightly",
    buildDate: "2024-09-27T00:06:30.167Z",
    commitHash: "dcfdcf9675b999891820b2ef983139184cae0802",
};
